
import React from "react";
import { Button } from "@/components/ui/button";

export interface TableEmptyStateProps {
  title?: string;
  description?: string;
  searchTerm?: string;
  setSearchTerm?: (term: string) => void;
}

export const TableEmptyState: React.FC<TableEmptyStateProps> = ({ 
  title = "Nenhum item encontrado", 
  description = "Não foram encontrados itens que correspondam aos seus critérios de pesquisa.",
  searchTerm,
  setSearchTerm
}) => {
  const hasSearchTerm = searchTerm && searchTerm.length > 0;
  
  const handleClearSearch = () => {
    if (setSearchTerm) {
      setSearchTerm("");
    }
  };

  return (
    <tr>
      <td colSpan={6} className="px-4 py-16">
        <div className="flex flex-col items-center justify-center text-center">
          <h3 className="text-lg font-medium text-gray-400 mb-1">{title}</h3>
          <p className="text-sm text-gray-500 mb-4">{description}</p>
          
          {hasSearchTerm && setSearchTerm && (
            <Button 
              variant="outline" 
              className="text-sm border-[#222A35] bg-[#1A2233] hover:bg-[#222A35] text-gray-300"
              onClick={handleClearSearch}
            >
              Limpar busca
            </Button>
          )}
        </div>
      </td>
    </tr>
  );
};

export default TableEmptyState;
